import React from "react";
import {
	Agama,
	Lokasi,
	Bank,
	Qualification,
	Hospital,
	Spesialis,
	TipeRegistrasi,
	KelasKunjungan,
	Poliklinik,
	PoliklinikSpesialis,
	Layanan,
	LayananRuang,
	JenisLayanan,
	JenisRawat,
	JenisAsuransi,
	Formula,
	Bed,
	JenisHarga,
	PerubahanJadwalDokterPage,
	JenisJasaPage,
	JenisFasilitasPage,
	JenisRikjangPage,
	JenisPaketPage,
	JasaPage,
	MasterFasilitas,
	MasterRikjang,
	PaketPage,
	TemplatePage,
	TipePembayaranPage,
	MovieListPage,
	TarifPage,
	MovieProfilingPage,
	GolonganDarahPage,
	PendidikanPage,
	TemaPage,
	SukuBangsaPage,
	PenanggungJawabPage,
	PekerjaanPage,
	KasPage,
	LoketAntrianKunjunganPage,
	AntrianLoketPage,
	LoketTextDisplayPage,
	KunjunganTextDisplayPage,
	RoleAccessPage,
	UsersAccessPage,
	MenuAccessPage,
	MenuAccessAccessPage,
	UserAccessPage,
	MenuRoleAccessPage,
	MasterGudangUtamaWMS,
	MasterSatuanWMS,
	MasterProdusenWMS,
	MasterSupplier,
	MasterUnitWMS,
	VerifikasiAccess,
	SettingSIMRS,
	DaftarNotifikasi,
	KategoriSetting,
	KonfigurasiPenjualan,
	KonfigurasiRS,
	Organisasi,
	Bundle,
	Counter,
	Encounter,
	KFA,
	MasterTag,
	KYC,
} from "./../WrapperLazyExport";

import {
	MS_AGAMA,
	MS_SH_LOKASI,
	MS_SH_ORG,
	MS_SH_BDL,
	MS_SH_CTR,
	MS_SH_KFA,
	MS_ASURANSI,
	MS_BANK,
	MS_BED,
	MS_FORMULA,
	MS_JENIS_HARGA,
	MS_KUALIFIKASI_PENDIDIKAN,
	MS_LAYANAN,
	MS_LAYANAN_RUANG,
	MS_POLIKLINIK,
	MS_POLIKLINIK_SPESIALIS,
	MS_TIPE_REGISTRASI,
	MS_RUMAH_SAKIT,
	MS_SPESIALIS,
	MS_KELAS_KUNJUNGAN,
	MS_JENIS_LAYANAN,
	MS_JENIS_RAWAT,
	PERUBAHAN_JADWAL_DOKTER,
	MS_JENIS_JASA,
	MS_JENIS_FASILITAS,
	MS_JENIS_RIKJANG,
	MS_JENIS_PAKET,
	MS_JASA,
	MS_FASILITAS,
	MS_TIPE_PEMBAYARAN,
	MS_MOVIE_LIST,
	MS_TARIF,
	MS_MOVIE_PROFILING,
	MS_RIKJANG,
	MS_PAKET,
	MS_TEMPLATE,
	MS_GOLONGAN_DARAH,
	MS_PENDIDIKAN,
	MS_TEMA,
	MS_SUKU_BANGSA,
	MS_PENANGGUNG_JAWAB,
	MS_PEKERJAAN,
	MS_KAS,
	MS_LOKET_ANTRIAN_KUNJUNGAN,
	MS_ANTRIAN_LOKET,
	MS_LOKET_TEXT_DISPLAY,
	MS_KUNJUNGAN_TEXT_DISPLAY,
	MA_ROLE,
	MA_MENU_ACCESS,
	MA_USER_ACCESS,
	MA_ROLE_ACCESS,
	MA_MENU,
	MA_USER,
	WMS_MS_GUDANG_UTAMA,
	WMS_MS_SATUAN,
	WMS_MS_PRODUSEN,
	WMS_MS_SUPPLIER,
	WMS_MS_UNIT,
	MA_VERIFIKASI_ACCESS,
	MA_SET_SIMRS,
	MA_NOTIFIKASI,
	MS_KATEGORI,
	MA_KONIFG_PENJUALAN,
	MA_KONIFG_RS,
	MS_TAG,
	MS_SH_ECT,
	MS_SH_KYC,
} from "App/constants";

export const menuMaster = {
	[MS_AGAMA]: <Agama />,

	// -------------------- Satu Sehat --------------------
	[MS_SH_LOKASI]: <Lokasi />,
	[MS_SH_ORG]: <Organisasi />,
	[MS_SH_BDL]: <Bundle />,
	[MS_SH_CTR]: <Counter />,
	[MS_SH_ECT]: <Encounter />,
	[MS_SH_KFA]: <KFA />,
	[MS_SH_KYC]: <KYC />,

	[MS_BANK]: <Bank />,
	[MS_KUALIFIKASI_PENDIDIKAN]: <Qualification />,
	[MS_RUMAH_SAKIT]: <Hospital />,
	[MS_SPESIALIS]: <Spesialis />,
	[MS_TIPE_REGISTRASI]: <TipeRegistrasi />,
	[MS_KELAS_KUNJUNGAN]: <KelasKunjungan />,
	[MS_POLIKLINIK]: <Poliklinik />,
	[MS_POLIKLINIK_SPESIALIS]: <PoliklinikSpesialis />,
	[MS_LAYANAN]: <Layanan />,
	[MS_LAYANAN_RUANG]: <LayananRuang />,
	[MS_JENIS_LAYANAN]: <JenisLayanan />,
	[MS_JENIS_RAWAT]: <JenisRawat />,
	[MS_ASURANSI]: <JenisAsuransi />,

	[MS_FORMULA]: <Formula />,
	[MS_JENIS_HARGA]: <JenisHarga />,
	[MS_BED]: <Bed />,

	[MS_JENIS_JASA]: <JenisJasaPage />,
	[MS_JENIS_FASILITAS]: <JenisFasilitasPage />,
	[MS_JENIS_RIKJANG]: <JenisRikjangPage />,
	[MS_JENIS_PAKET]: <JenisPaketPage />,
	[MS_JASA]: <JasaPage />,
	[MS_FASILITAS]: <MasterFasilitas />,
	[MS_RIKJANG]: <MasterRikjang />,
	[MS_PAKET]: <PaketPage />,
	[MS_TEMPLATE]: <TemplatePage />,

	[MS_GOLONGAN_DARAH]: <GolonganDarahPage />,
	[MS_PENDIDIKAN]: <PendidikanPage />,
	[MS_TEMA]: <TemaPage />,

	[MS_SUKU_BANGSA]: <SukuBangsaPage />,
	[MS_PENANGGUNG_JAWAB]: <PenanggungJawabPage />,
	[MS_PEKERJAAN]: <PekerjaanPage />,
	[MS_KAS]: <KasPage />,

	[MS_TIPE_PEMBAYARAN]: <TipePembayaranPage />,
	[MS_MOVIE_LIST]: <MovieListPage />,
	[MS_TARIF]: <TarifPage />,
	[MS_MOVIE_PROFILING]: <MovieProfilingPage />,

	[MS_LOKET_ANTRIAN_KUNJUNGAN]: <LoketAntrianKunjunganPage />,
	[MS_ANTRIAN_LOKET]: <AntrianLoketPage />,
	[MS_LOKET_TEXT_DISPLAY]: <LoketTextDisplayPage />,
	[MS_KUNJUNGAN_TEXT_DISPLAY]: <KunjunganTextDisplayPage />,

	[PERUBAHAN_JADWAL_DOKTER]: <PerubahanJadwalDokterPage />,

	[MA_ROLE]: <RoleAccessPage />,
	[MA_USER]: <UsersAccessPage />,
	[MA_MENU]: <MenuAccessPage />,
	[MA_MENU_ACCESS]: <MenuAccessAccessPage />,
	[MA_USER_ACCESS]: <UserAccessPage />,
	[MA_ROLE_ACCESS]: <MenuRoleAccessPage />,
	[MS_KATEGORI]: <KategoriSetting />,

	[MA_VERIFIKASI_ACCESS]: <VerifikasiAccess />,
	[MA_SET_SIMRS]: <SettingSIMRS />,
	[MA_KONIFG_PENJUALAN]: <KonfigurasiPenjualan />,

	[MA_KONIFG_RS]: <KonfigurasiRS />,
	[MA_NOTIFIKASI]: <DaftarNotifikasi />,

	[WMS_MS_GUDANG_UTAMA]: <MasterGudangUtamaWMS />,
	[WMS_MS_SATUAN]: <MasterSatuanWMS />,
	[WMS_MS_PRODUSEN]: <MasterProdusenWMS />,
	[WMS_MS_SUPPLIER]: <MasterSupplier />,
	[WMS_MS_UNIT]: <MasterUnitWMS />,

	[MS_TAG]: <MasterTag />,
};
